import React from 'react';

const ExtraInvoiceField = ({ value }) => {
  if (!value?.invoicePinv) return <div>-</div>;

  const invoiceNumber = value?.invoicePinv?.number;

  return <div>{invoiceNumber}</div>;
};
export default ExtraInvoiceField;
